import allStoresAppRoutes from './allStoresAppRoutes';
import giftCardsStoreAppRoutes from './giftCardsStoreAppRoutes';
import liquorStoreAppRoutes from './liquorStoreAppRoutes';
import {StoreType, TargetStoreType} from './types';

const appRoutes = (ecommerceDisabled: boolean, isLoggedIn: boolean, storeLoyaltyEnabled: boolean) => [
  ...liquorStoreAppRoutes(ecommerceDisabled, isLoggedIn, storeLoyaltyEnabled),
  ...giftCardsStoreAppRoutes,
  ...allStoresAppRoutes,
];

export const getRoutesForStoreType = (
  storeType: StoreType,
  storeLoyaltyEnabled: boolean,
  ecommerceDisabled: boolean = false,
  isLoggedIn: boolean = false,
) => {
  const targetStoreType =
    storeType === StoreType.GiftCardStore
      ? TargetStoreType.GiftCardStore
      : TargetStoreType.LiquorStore;
  return appRoutes(ecommerceDisabled, isLoggedIn, storeLoyaltyEnabled).filter(
    route =>
      route.targetStoreType === targetStoreType ||
      route.targetStoreType === TargetStoreType.All,
  );
};
